import { Flex, Spacer, Box, Divider, Radio } from '@chakra-ui/react';
import BEControlGroup from '@molecules/BEControlGroup';

const DemoRadio = () => {
  return (
    <Box>
      <h2>Radio</h2>
      <Divider m={2} />
      <Flex align={'center'}>
        <p>Horizontal Layout</p>
        <Spacer />
        <BEControlGroup direction="horizontal">
          <Radio value="1">Radio Label1</Radio>
          <Radio value="2">Radio Label2</Radio>
          <Radio value="3">Radio Label3</Radio>
        </BEControlGroup>
      </Flex>
      <Divider m={2} />
      <Flex align={'center'}>
        <p>Vertical Layout</p>
        <Spacer />
        <BEControlGroup direction="vertical">
          <Radio value="1">Radio Label1</Radio>
          <Radio value="2">Radio Label2</Radio>
          <Radio value="3">Radio Label3</Radio>
        </BEControlGroup>
      </Flex>
    </Box>
  );
};

export default DemoRadio;
